// import React, { useState, useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { Modal, ModalBody, Button, Input, Row, Col, InputGroup } from 'reactstrap';
// import { addToCart } from '../../../slices/cart/CartSlice';
// import CartModal from '../../Modal/CartModal';

// export const ItemDetailPopup = ({ item, onClose, orgInfo }) => {
//   const dispatch = useDispatch();
//   const [quantity, setQuantity] = useState(1);
//   const [isCartOpen, setIsCartOpen] = useState(false);

//   // Null check for item
//   if (!item) {
//     return null; // Return null if item is null or undefined
//   }

//   // Calculate the discounted price
//   const calculateDiscountedPrice = (item) => {
//     if (item?.discountDetail?.discountPercentage) {
//       const discountPercentage = item.discountDetail.discountPercentage;
//       const discounted = item.price * (1 - discountPercentage / 100);
//       return Number(discounted.toFixed(2));
//     }
//     return item.price;
//   };

//   const discountedPrice = calculateDiscountedPrice(item);
//   const totalPrice = discountedPrice * quantity;

//   // Check if OMS is enabled
//   const hasOMS = orgInfo?.organization?.hasOMS || false;

//   const handleIncrement = () => {
//     setQuantity(quantity + 1);
//   };

//   const handleDecrement = () => {
//     if (quantity > 1) {
//       setQuantity(quantity - 1);
//     }
//   };

//   const handleAddToCart = () => {
//     if (!item?.id) {
//       console.error("Cannot add item to cart: Invalid item ID");
//       return;
//     }

//     const itemToAdd = {
//       id: item.id,
//       title: item.title,
//       price: discountedPrice,
//       originalPrice: item.price,
//       quantity: quantity,
//       displayImage: item.displayImage,
//       description: item.description || '',
//       discountDetail: item.discountDetail || null,
//       currency: 'NRS.'
//     };

//     try {
//       dispatch(addToCart(itemToAdd));
//       setIsCartOpen(true); // Open the cart modal
//     } catch (error) {
//       console.error("Error adding item to cart:", error);
//     }
//   };

//   const toggleCart = () => {
//     setIsCartOpen(!isCartOpen);
//   };

//   return (
//     <Modal isOpen={!!item} toggle={onClose} centered size="lg">
//       <ModalBody className="p-4">
//         <Row>
//           {/* Left Side: Image */}
//           <Col md={6} className="text-center mb-4 mb-md-0">
//             <div className="image-container-popup">
//               <img
//                 src={item?.displayImage?.getCDNUrl() || "/api/placeholder/400/300"}
//                 alt={item?.title}
//                 className="img-fluid rounded shadow-sm"
//               />
//             </div>
//           </Col>

//           {/* Right Side: Text, Description, Price, and Quantity Controls */}
//           <Col md={6} className="d-flex flex-column">
//             <h4 className="fw-bold text-capitalize">{item?.title}</h4>
//             <p className="text-muted">{item?.description}</p>

//             {/* Display Discounted Price */}
//             {item?.discountDetail ? (
//               <div className='d-flex flex-column'>
//                 <span className="text-muted text-decoration-line-through me-2">
//                   NRS {item?.price}
//                 </span>
//                 <span className="fw-bold text-danger">
//                   NRS {discountedPrice.toFixed(2)}
//                 </span>
//               </div>
//             ) : (
//               <span className="fw-bold">NRS {item?.price}</span>
//             )}

//             {hasOMS && (
//               <>
//                 <div className="d-flex flex-column justify-content-between mt-4">
//                   <span className="fw-bold fs-6">Total Price: NRS.{totalPrice.toFixed(2)}</span>
//                   <div className="mb-4">
//                     <InputGroup style={{ maxWidth: "150px" }}>
//                       <Button
//                         color="secondary"
//                         outline
//                         onClick={handleDecrement}
//                         disabled={quantity === 1}
//                       >
//                         -
//                       </Button>
//                       <Input
//                         type="number"
//                         value={quantity}
//                         onChange={(e) =>
//                           setQuantity(Math.max(1, parseInt(e.target.value) || 1))
//                         }
//                         className="text-center"
//                       />
//                       <Button
//                         color="secondary"
//                         outline
//                         onClick={handleIncrement}
//                       >
//                         +
//                       </Button>
//                     </InputGroup>
//                   </div>
//                 </div>

//                 {/* Add to Cart Button - Positioned at the bottom-right */}
//                 <div className="mt-4 d-flex justify-content-end">
//                   <Button
//                     onClick={handleAddToCart}
//                     color="danger"
//                     size="sm"
//                     outline
//                     className="d-flex align-items-center justify-content-center gap-1"
//                   >
//                     <span>
//                       <i className="ri-shopping-cart-line fs-6"></i>
//                     </span>
//                     <span>Add to Cart</span>
//                   </Button>
//                 </div>
//               </>
//             )}
//           </Col>
//         </Row>
//         <CartModal isOpen={isCartOpen} toggle={toggleCart} orgInfo={orgInfo} />
//       </ModalBody>
//     </Modal>
//   );
// };

import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Modal,
  ModalBody,
  Button,
  Input,
  Row,
  Col,
  InputGroup,
  ModalHeader,
} from "reactstrap";
import { addToCart } from "../../../slices/cart/CartSlice";
import CartModal from "../../Modal/CartModal";

export const ItemDetailPopup = ({ item, onClose, orgInfo }) => {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const [isCartOpen, setIsCartOpen] = useState(false);

  // Null check for item after hooks
  if (!item) {
    return null; // Return null if item is null or undefined
  }

  // Calculate the discounted price for a given attribute or item price
  const calculateDiscountedPrice = (price) => {
    if (item?.discountDetail?.discountPercentage) {
      const discountPercentage = item.discountDetail.discountPercentage;
      const discounted = price * (1 - discountPercentage / 100);
      return Number(discounted.toFixed(2));
    }
    return price;
  };

  // Use the first attribute's rate as the default price, or fall back to item.price
  const defaultPrice =
    item.menuAttributes?.length > 0 ? item.menuAttributes[0].rate : item.price;
  const discountedPrice = calculateDiscountedPrice(defaultPrice);
  const totalPrice = discountedPrice * quantity;

  // Check if OMS is enabled
  const hasOMS = orgInfo?.organization?.hasOMS || false;

  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleAddToCart = () => {
    if (!item?.id) {
      console.error("Cannot add item to cart: Invalid item ID");
      return;
    }

    if (item.menuAttributes?.length > 0 && !item.menuAttributes[0]) {
      console.error("Cannot add item to cart: No valid attributes");
      return;
    }

    const itemToAdd = {
      id: item.id,
      title: item.title,
      price: discountedPrice,
      originalPrice: defaultPrice,
      quantity: quantity,
      displayImage: item.displayImage,
      description: item.description || "",
      discountDetail: item.discountDetail || null,
      currency: "NRS",
      // Include the first attribute if available
      attribute:
        item.menuAttributes?.length > 0
          ? { id: item.menuAttributes[0].id, name: item.menuAttributes[0].name }
          : null,
    };

    try {
      dispatch(addToCart(itemToAdd));
      setIsCartOpen(true); // Open the cart modal
    } catch (error) {
      console.error("Error adding item to cart:", error);
    }
  };

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  return (
    <Modal isOpen={!!item} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose} className="border-0 pb-0"></ModalHeader>
      <ModalBody className="p-4">
        <Row>
          {/* Left Side: Image */}
          <Col md={6} className="text-center mb-4 mb-md-0">
            <div className="image-container-popup">
              <img
                src={
                  item?.displayImage?.getCDNUrl() || "/api/placeholder/400/300"
                }
                alt={item?.title}
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </Col>

          {/* Right Side: Text, Description, Price, and Quantity Controls */}
          <Col md={6} className="d-flex flex-column">
            <h4 className="fw-bold text-capitalize">{item?.title}</h4>
            <p className="text-muted">{item?.description}</p>

            {/* Display menuAttributes if available */}
            {item.menuAttributes && item.menuAttributes.length > 0 ? (
              <div className="mb-3">
                <h6 className="fw-bold">Available Sizes:</h6>
                {item.menuAttributes.map((attribute) => {
                  const attrDiscountedPrice = calculateDiscountedPrice(
                    attribute.rate
                  );
                  return (
                    <div
                      key={attribute.id}
                      className="d-flex justify-content-between align-items-center mb-2"
                    >
                      <span>{attribute.name}</span>
                      <div>
                        {item.discountDetail ? (
                          <>
                            <span className="text-muted text-decoration-line-through me-2">
                              NRS {attribute.rate.toFixed(2)}
                            </span>
                            <span className="fw-bold text-danger">
                              NRS {attrDiscountedPrice.toFixed(2)}
                            </span>
                          </>
                        ) : (
                          <span className="fw-bold">
                            NRS {attribute.rate.toFixed(2)}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="mb-3">
                <span className="fw-bold">NRS {item?.price.toFixed(2)}</span>
              </div>
            )}

            {hasOMS && (
              <>
                <div className="d-flex flex-column justify-content-between mt-4">
                  <span className="fw-bold fs-6">
                    Total Price: NRS {totalPrice.toFixed(2)}
                  </span>
                  <div className="mb-4">
                    <InputGroup style={{ maxWidth: "150px" }}>
                      <Button
                        color="secondary"
                        outline
                        onClick={handleDecrement}
                        disabled={quantity === 1}
                      >
                        -
                      </Button>
                      <Input
                        type="number"
                        value={quantity}
                        onChange={(e) =>
                          setQuantity(
                            Math.max(1, parseInt(e.target.value) || 1)
                          )
                        }
                        className="text-center"
                      />
                      <Button
                        color="secondary"
                        outline
                        onClick={handleIncrement}
                      >
                        +
                      </Button>
                    </InputGroup>
                  </div>
                </div>

                {/* Add to Cart Button - Positioned at the bottom-right */}
                <div className="mt-4 d-flex justify-content-end">
                  <Button
                    onClick={handleAddToCart}
                    color="danger"
                    size="sm"
                    outline
                    className="d-flex align-items-center justify-content-center gap-1"
                    disabled={
                      item.menuAttributes?.length > 0 && !item.menuAttributes[0]
                    }
                  >
                    <span>
                      <i className="ri-shopping-cart-line fs-6"></i>
                    </span>
                    <span>Add to Cart</span>
                  </Button>
                </div>
              </>
            )}
          </Col>
        </Row>
        <CartModal isOpen={isCartOpen} toggle={toggleCart} orgInfo={orgInfo} />
      </ModalBody>
    </Modal>
  );
};
